export default {
  success: "success",
  error: "error",
  loading: "loading",
  ready: "ready",
};
